import moment from 'moment';
import config from 'config';

const calculateProgress = (start, end, latency = 0) => {
  const startTime = moment(start);
  const endTime = moment(end);
  const currentTime = moment().add(config.timeDiffFromServer, 'm');
  const duration = endTime.diff(startTime, 'minutes');
  const elapsedTime = currentTime.subtract(latency, 'seconds').diff(startTime, 'minutes');

  return elapsedTime / duration;
};

export default calculateProgress;
